import { MenuItemType } from '../../../utils/types'
import { WImage } from '../../atoms'
import styles from './IconCard.module.sass'

interface Props {
  className?: string
  item?: MenuItemType
  variant?: 'default' | 'oneLine'
  editMode?: boolean
}

const IconCard = (props: Props) => {
  const { className = '', item = undefined, variant = 'default', editMode = false } = props

  return (
    <div className={`${styles.root} ${className} ${styles[`root--${variant}`]}`}>
      {item.image && (
        <div className={styles.imageBox}>
          <WImage
            maxHeight={80}
            maxWidth={80}
            src={item.image}
            alt={item?.imageAlt}
            objectFit="contain"
          />
        </div>
      )}
      {item.name && <h3 className={styles.detailDescription}>{item.name}</h3>}
    </div>
  )
}

export default IconCard
